import { useEffect } from "react";

import { Button, Form, Input, message, Modal } from "antd";

import api from "services/api.service";
import phoneIcon from "data/icons/phone.svg";
import { formatPhoneNumber } from "services/data.service";

interface IProps {
  getContactsList: () => void;
  editingContact: any;
  setEditingContact: (contact: any) => void;
}

const ContractorContactEditModal = ({
  getContactsList,
  editingContact,
  setEditingContact,
}: IProps) => {
  const [ form ] = Form.useForm();

  const handleCompleteForm = async (values: any) => {
    console.log(values);
    try {
      await api.contactUpdate(editingContact.id, {
        email: values.email,
        first_name: values.name,
        phone_number: values.phone_number,
      });

      message.success("Contact was edited.");
      setEditingContact(null);
      await getContactsList();
    } catch (e: any) {
      message.error(e.response.data.error || e.error || "Something went wrong!");
    }
  };

  useEffect(() => {
    if (editingContact) {
      form.setFieldsValue({
        name: editingContact.first_name,
        email: editingContact.email,
        phone_number: formatPhoneNumber(editingContact.phone_number || ""),
      });
    }

    return () => {
      form.setFieldsValue({});
    }
  }, [ editingContact ]);
  
  return (
    <Modal
      className="user-accept-modal-wrapper"
      open={ !!editingContact }
      onCancel={ () => setEditingContact(null) }
      footer={ null }
      width={ 500 }
    >
      <Form
        className="contractor-form"
        layout="vertical"
        form={ form }
        onFinish={ handleCompleteForm }
      >
        <Form.Item
          label="Name"
          name="name"
          rules={ [ { required: true, message: "Please input name!" } ] }
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={ [ { required: true, message: "Please input email!" } ] }
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Phone number"
          name="phone_number"
        >
          <Input
            placeholder="+375 (00) 000-00-00"
            prefix={ <img src={ phoneIcon } alt="" style={ { marginRight: "5px" } } /> }
            onChange={ (e) => form.setFieldsValue({ phone_number: formatPhoneNumber(e.target.value) }) }
          />
        </Form.Item>

        <div className="action-wrapper">
          <Button
            type="primary"
            htmlType="submit"
          >
            Save
          </Button>

          <Button onClick={ () => setEditingContact(null) }>
            Cancel
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ContractorContactEditModal;
